import { register } from "@/helpers/stimulus"

import SnackBarController from "../controllers/snackbar_controller"
import WishlistController from "../controllers/wishlist_controller"
import WishlistPageController from "../controllers/wishlist_page_controller"
import LoaderController from "../controllers/loader_controller"

const setupStimulus = (): void => {
  register("loader", LoaderController)
  register("snackbar", SnackBarController)
  register("wishlist", WishlistController)
  register("wishlist-page", WishlistPageController)
}

setupStimulus()
